import React from 'react';
import {
    Dropoff,
    Pickup,
    DropTrailer,
    PickupTrailer,
    ActivityResumed,
    InactivityDetected,
    GeofenceDeparture,
    Hauler,
    Processor,
    Producer,
    // wrap
} from '../symbols';
import { mui5ThemeObject } from '../../../../styles/mm-theme-fuse';

export const MarkerIcon = ({ Icon, size = 38 }) => {
    return <Icon width={size} height={size} />;
};

export const getMarkerMap = (localization) => {
    return {
        rawMilkDropoff: {
            label: 'Dropoff',
            marker: <MarkerIcon Icon={Dropoff} />,
            colour: mui5ThemeObject.palette.info.main,
        },
        rawMilkPickup: {
            label: 'Pickup',
            marker: <MarkerIcon Icon={Pickup} />,
            colour: mui5ThemeObject.palette.info.main,
        },
        dropTrailer: {
            label: 'Drop Trailer',
            marker: <MarkerIcon Icon={DropTrailer} />,
            colour: mui5ThemeObject.palette.warning.main,
        },
        pickupTrailer: {
            label: 'Enter Route Session',
            marker: <MarkerIcon Icon={PickupTrailer} />,
            colour: mui5ThemeObject.palette.warning.main,
        },
        ActivityResumed: {
            label: 'Activity Resumed',
            marker: <MarkerIcon Icon={ActivityResumed} />,
            colour: mui5ThemeObject.palette.success.main,
        },
        InactivityDetected: {
            label: 'Inactivity Detection',
            marker: <MarkerIcon Icon={InactivityDetected} />,
            colour: mui5ThemeObject.palette.grey.main,
        },
        GeofenceDeparture: {
            label: 'Geofence Departure',
            marker: <MarkerIcon Icon={GeofenceDeparture} />,
            colour: mui5ThemeObject.palette.warning.main,
        },
        processor: {
            label: localization?.general?.processor_singular || 'Processor',
            marker: <MarkerIcon Icon={Processor} />,
        },
        producer: {
            label: 'Producer',
            marker: <MarkerIcon Icon={Producer} />,
        },
        transport: {
            label: localization?.general?.hauling_singular || 'Hauler',
            marker: <MarkerIcon Icon={Producer} />,
        },
        driver: {
            label: 'Driver',
            marker: <MarkerIcon Icon={Hauler} />,
        },
    };
};

export const getZoomFromRadius = (radius) => {
    if (radius < 200) {
        return 16;
    }
    if (radius <= 1000) {
        return 15;
    }
    if (radius <= 3500) {
        return 13;
    }
    if (radius <= 8500) {
        return 12;
    }
    if (radius <= 17000) {
        return 11;
    }
    if (radius <= 25000) {
        return 10;
    }

    // this comfortably fits 120,000m radius
    return 8;
};
